<template>
  <div class="px-4 sm:px-0">
    <div class="sm:order-first flex sm:flex-col flex-row flex-wrap sm:flex-nowrap gap-2">
      <p v-if="isMobile" class="text-[#78797A] text-sm font-normal leading-16 w-full">İlgini çeken kategorileri seç</p>
      <OButton
        pure
        class="
          h-9
          sm:w-[125px] sm:px-4
          px-3
          py-2
          flex
          justify-start
          items-center
          rounded-lg
          sm:rounded-xl
          bg-[#EEF0F4]
          border-[1.5px] border-[#e2e5ed]
          text-[#424242] text-sm
          sm:text-md
          font-normal
        "
        :class="isAllSelected && 'kesfetBorder'"
        @click="selectAllCategories"
      >
        Tümü
      </OButton>
      <div v-for="category in categories.slice(0, visibleCategories)" :key="category.id" class="flex sm:mt-2">
        <OButton
          pure
          class="
            h-9
            sm:min-w-[125px] sm:w-max sm:px-4
            px-3
            py-2
            flex
            items-center
            justify-start
            rounded-lg
            sm:rounded-xl
            bg-[#EEF0F4]
            border-[1.5px] border-[#e2e5ed]
            text-[#424242] text-sm
            sm:text-md
            font-normal
          "
          :class="selectedCategoriesIds.includes(category.id) && !isAllSelected && 'kesfetBorder'"
          @click="selectCategory(category.id, category.name)"
        >
          <span v-if="!selectedCategoriesIds.includes(category.id)" class="mr-0.5">+</span>
          {{ category.name }}
        </OButton>
      </div>
      <OButton pure class="u-center text-[#306AFF] px-4 py-2" @click="toggleCategory()">
        <OIcon
          icon="chevron-left-blue"
          :svg-class="visibleCategories === minVisibleCategories ? '-rotate-90' : 'rotate-90'"
          class="text-[#306AFF]"
        />
        <p class="ml-2 text-sm sm:text-md font-medium">{{ visibleCategories === minVisibleCategories ? 'Genişlet' : 'Daralt' }}</p>
      </OButton>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted, watch, inject } from '@nuxtjs/composition-api';

import { useDevice } from '@/composables/useDevice';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { getMainCategories } from '~/modules/category/utils/categoryUtils';
import { OButton, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon, OButton },
  setup(props, { emit }) {
    const { isMobile } = useDevice();
    const { lastCategory } = inject('lastCategory');

    const categories = ref([]);
    const minVisibleCategories = computed(() => (isMobile.value ? 6 : 4));
    const visibleCategories = ref(minVisibleCategories.value);
    const isAllSelected = ref(false);
    const selectedCategories = ref([]);
    const selectedCategoriesIds = computed(() => selectedCategories.value.map((a) => a.id));
    categories.value = getMainCategories().map((v) => {
      return {
        name: v.name,
        id: v._id,
      };
    });

    const toggleCategory = () => {
      if (visibleCategories.value === minVisibleCategories.value) visibleCategories.value = categories.value.length;
      else visibleCategories.value = minVisibleCategories.value;
    };
    watch(minVisibleCategories, (_new, old) => {
      visibleCategories.value = _new;
    });

    const selectAllCategories = () => {
      selectedCategories.value = [];
      isAllSelected.value = true;
      localStore.setItem('o-followed-categories', selectedCategories.value);
      location.reload();
      window.dataLayer.push({
        event: 'filtered',
        event_category: 'Takip Ettiklerim', // Takip Ettiklerim, Trendler, Sana Özel vs. alanındaki değerler gelecek.
        event_action: 'Clicked',
        event_label: 'Tümü', // Hangi filtre seçildiyse o bilgi gelecek. Eğer Takip Ettiklerim haricinde bir filtre seçildiyse, örneğin Trendler gibi, o zaman Trendler değeri buraya da gelecek.
      });
    };

    const selectCategory = (id, name) => {
      if (isAllSelected.value) {
        selectedCategories.value = [];
        isAllSelected.value = false;
      }
      if (selectedCategoriesIds.value.includes(id)) {
        selectedCategories.value.splice(selectedCategoriesIds.value.indexOf(id), 1);
        if (selectedCategories.value.length === 0) {
          selectAllCategories();
          return;
        }
      } else selectedCategories.value.push({ id, name });
      localStore.setItem('o-followed-categories', selectedCategories.value);
      window.dataLayer.push({
        event: 'filtered',
        event_category: 'Takip Ettiklerim', // Takip Ettiklerim, Trendler, Sana Özel vs. alanındaki değerler gelecek.
        event_action: 'Clicked',
        event_label: lastCategory(), // Hangi filtre seçildiyse o bilgi gelecek. Eğer Takip Ettiklerim haricinde bir filtre seçildiyse, örneğin Trendler gibi, o zaman Trendler değeri buraya da gelecek.
      });

      emit('handleCategoryChange');
    };

    onMounted(() => {
      const followedCategories = localStore.getItem('o-followed-categories');
      if (followedCategories) {
        selectedCategories.value = followedCategories;
        categories.value = categories.value?.sort((x, y) => {
          return followedCategories.map((a) => a.id).indexOf(y.id) - followedCategories.map((a) => a.id).indexOf(x.id);
        });
      } else localStore.setItem('o-followed-categories', []);
      if (selectedCategories.value.length === 0) isAllSelected.value = true;
    });

    return {
      toggleCategory,
      selectCategory,
      selectAllCategories,
      categories,
      isMobile,
      isAllSelected,
      visibleCategories,
      minVisibleCategories,
      selectedCategories,
      selectedCategoriesIds,
    };
  },
});
</script>

<style lang="scss" scoped>
.kesfetBorder {
  background-image: linear-gradient(to right, #306aff, #cc4ad4);
  background-origin: border-box;
  box-shadow: inset 0 100vw white;
  border: 1.5px solid transparent;
}
</style>
